/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOS4yIDE0LjVDMTIuOCAxNC41IDE1LjcgMTEuNiAxNS43IDhDMTUuNyA0LjQgMTIuOCAxLjUgOS4yIDEuNUM1LjYgMS41IDIuOCA0LjQgMi44IDhIMC4xOTk5OTdMMy4yIDExTDYuMiA4SDMuOEMzLjggNSA2LjMgMi41IDkuMyAyLjVDMTIuMyAyLjUgMTQuOCA1IDE0LjggOEMxNC44IDExIDEyLjMgMTMuNSA5LjMgMTMuNVYxNC41SDkuMloiIGZpbGw9ImluaGVyaXQiLz48L3N2Zz4=";